import * as React from "react";
import moment from "moment";
import { UserAvatar } from "../../../../components/render-file/UserAvatar";
import { OwnerUser, convertPascalCaseToWords } from "../../../../core";
import BlankProPic from "../../../../styles/images/no-user-sm.png";
import PhoneNumberCopy from "../../../../components/phoneNumberCopy/PhoneNumberCopy";
import EmailLink from "../../../../components/emailLink/EmailLink";

export enum DocumentCopyType {
  ClientCopy = 'Client Copy',
  LandlordCopy = 'Landlord Copy',
  SignedClientDocument = 'Signed Client Document',
  SignedLandloardDocument = 'Signed Landlord Document',
}

  export interface Action {
    action: string;
    doneBy: OwnerUser;
    comment?: string;
    copyType?: DocumentCopyType;
  }
  

const List: React.FunctionComponent<{
  onView: (id: string) => void;
  documents: any[];
  isSigned?: boolean;
  title?: string;
  stage?: string;
}> = (props) => {
  const [propDropdown, setPropDropdown] = React.useState<number | null>(null);
  const [dropPos, setDropPos] = React.useState<{
    open: boolean;
    x: string;
    y: string;
    id: string;
    fieldName: string;
  }>();

  
  const dropdownClick = (event: any, id: string, fieldName: string) => {
    const pos = event.target.getBoundingClientRect();
    const x = pos.x + "px";
    const y = pos.y + pos.height + "px";
    setDropPos({ open: !dropPos?.open, x, y, id, fieldName });
  };

  const renderFieldDetails = (fieldName: string, fieldArrayValues: any) => {
    return (
      <div
        className="position-absolute bg-white shadow w-100 pt-2"
        style={{ right: 0, maxWidth: "435px", zIndex: 100 }}
      >
        <div className="px-3 pt-2 font-normal text-gray-600 font-weight-semibold my-1">
          {fieldName}
        </div>
        {fieldArrayValues?.map((item: any, index: number) => {
          return (
            <div className="d-flex align-items-center text-nowrap py-2 px-3 border-bottom" key={index}>
              <img
                src={item?.profileImage ? item?.profileImage : BlankProPic}
                alt="image_not_found"
                className="img-cover rounded-circle img-responsive mr-2"
                width={26}
                height={26}
              />
              <div className="font-weight-semibold">
                <div className="font-normal">
                  {item.contactName}
                </div>
                <div className="font-xs text-gray-600 d-flex align-items-center">
                {item.phones.map((itm:any, idx:number)=><><PhoneNumberCopy>{itm.phone}</PhoneNumberCopy>{++idx < item?.phones?.length ? ', ' : '' }</>)}
                </div>
                <div className="font-xs text-gray-600 d-flex align-items-center">
                  {item.emails.map((itm:any, idx:number)=><><EmailLink>{itm.email}</EmailLink>{++idx < item.emails.length ? ', ' : ''}</>)}
                </div>
                <div className="font-xs text-gray-600 d-flex align-items-center">
                  {item?.type}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );

  };

  const getLastActivity = (version:any) =>{
    const clientLastActivity = version.actions?.filter((item:Action)=>item.copyType === DocumentCopyType.ClientCopy)?.at(-1)
    const LandlordLastActivity = version.actions?.filter((item:Action)=>item.copyType === DocumentCopyType.LandlordCopy)?.at(-1)

    return <>
        {clientLastActivity &&
          <div className="pt-2">
            <div className="d-flex align-items-center">
              Client{" - "}{clientLastActivity.action}{" "}By
              {" "}{clientLastActivity.doneBy.name}
            </div>

            <div className="text-nowrap">
              <span className="text-gray-600">On</span>{" "}
              {moment(
                clientLastActivity?.createdAt
              ).format("DD MMM YYYY hh:mm A")}{" "}
            </div>
        </div>}

        {LandlordLastActivity && <div className="pt-2">
          <div className="d-flex align-items-center">
           Landlord{" - "}{LandlordLastActivity.action}{" "}By{" "}
            {LandlordLastActivity.doneBy.name}
          </div>

          <div className="text-nowrap">
            <span className="text-gray-600">On</span>{" "}
            {moment(
              LandlordLastActivity?.createdAt
            ).format("DD MMM YYYY hh:mm A")}{" "}
          </div>
       </div>}

    </>
  }

  return !!props.documents?.length ? (
    <>
      <div className="">
        <div className="table-responsive">
          <table className="table table-bordered w-100">
            <tr>
              <th
                className="font-sm font-weight-semibold"
                style={{ width: "175px", minWidth: "175px", maxWidth: "175px" }}
              >
                Created By
              </th>

              <th
                className="font-sm font-weight-semibold"
                style={{ maxWidth: "400px", width: "400px" }}
              >
                Property
              </th>
              <th
                className="font-sm font-weight-semibold"
                style={{ width: "175px", minWidth: "175px", maxWidth: "175px" }}
              >
                Requested By / Approved By
              </th>
              <th
                className="font-sm font-weight-semibold"
                style={{ width: "350px", minWidth: "350px", maxWidth: "350px" }}
              >
                Last Activity
              </th>

              <th className="font-sm font-weight-semibold"> Action</th>
              <th
                className="font-sm font-weight-semibold"
                style={{ width: "50px", minWidth: "50px", maxWidth: "50px" }}
              ></th>
            </tr>
            {props?.documents?.map((version, index) => {
              const unitDetails = version?.proposedPropertyDetails;

              return (
                <>
                  <tr className="cursor-pointer" key={version?._id}>
                    <td className="font-sm font-weight-semibold">
                      {version?.createdBy?.name && (
                        <>
                          <div className="d-flex align-items-center">
                            <div className="mr-2">
                              <div className="avatar-progress avatar-progress--xs position-relative cursor-pointer">
                                <svg>
                                  <circle
                                    r="12"
                                    cx="50%"
                                    cy="50%"
                                    className="default"
                                  ></circle>
                                  <circle
                                    r="12"
                                    cx="50%"
                                    cy="50%"
                                    className="progress"
                                    stroke-dasharray="117"
                                    stroke-dashoffset="75"
                                  ></circle>
                                </svg>
                                <UserAvatar
                                  id={version.createdBy?._id}
                                  className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
                                  alt=""
                                  title={version.createdBy?.name}
                                  imageUrl={version.createdBy?.photo?.location}
                                  image={version.createdBy?.photo}
                                ></UserAvatar>
                              </div>
                            </div>
                            Created by {version?.createdBy?.name}
                          </div>
                          <div className="mt-2 text-nowrap">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(version?.createdAt).format(
                              "DD MMM YYYY hh:mm A"
                            )}{" "}
                          </div>
                        </>
                      )}
                    </td>

                    <td className="font-sm font-weight-semibold">
                      <div className="d-flex">
                        <div className="py-1">
                          <img
                            src={
                              version?.proposedPropertyDetails[0]?.propertyDetails
                                ?.propertyDetailsFromProject?.propertyCoverImage
                            }
                            alt={
                              version?.proposedPropertyDetails[0]?.propertyDetails
                                ?.propertyDetailsFromProject?.projectName
                            }
                            width={59}
                            height={45}
                            className="img-cover rounded"
                          />
                        </div>
                        <div className="py-1 w-100 pl-3">
                          <div className="d-flex">
                            <div className="font-sm text-truncate">
                              {
                                version?.proposedPropertyDetails[0]
                                  ?.propertyDetails?.propertyDetailsFromProject
                                  ?.propertyName
                              }
                            </div>
                          </div>
                          <div className="font-xs text-gray-500 text-wrap pt-1 font-weight-light text-gray-500 ">
                            {
                              version?.proposedPropertyDetails[0]?.propertyDetails
                                ?.propertyDetailsFromProject?.propertyAddress
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="font-sm">
                      {props.stage === "Draft" && version?.document && version?.document?.internalApproval === undefined && (
                        <>  
                          <div className=" mb-1">
                           Client - Requested by {version?.createdBy?.name}
                            <span className="text-gray-600">{" "}On</span>{" "}
                              {moment(version?.document?.createdAt).format(
                                "DD MMM YYYY hh:mm A"
                              )}{" "}
                          </div>
                        </>
                      )}
                      {props.stage === "Draft" && version?.seperateDocumentForLandlord &&version?.seperateDocumentForLandlord?.internalApproval === undefined && (
                        <>  
                          <div className=" mb-1">
                           Landlord - Requested by {version?.createdBy?.name}
                            <span className="text-gray-600">{" "}On</span>{" "}
                              {moment(version?.seperateDocumentForLandlord?.createdAt).format(
                                "DD MMM YYYY hh:mm A"
                              )}{" "}
                          </div>
                        </>
                      )}
                      {version.document?.internalApproval?.status ===
                        "Pending" && (
                        <>
                          <div className="d-flex align-items-center">
                          Client - Requested by{" "}
                            {
                              version.document?.internalApproval?.requestedBy
                                ?.name
                            }
                          </div>
                          <div className="text-nowrap">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              version.document?.internalApproval?.requestedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                      {version.document?.internalApproval?.status ===
                        "Approved" && (
                        <>
                          <div className="d-flex align-items-center">
                            Client - Invoice Approved by{" "}
                            {
                              version.document?.internalApproval?.approvedBy
                                ?.name
                            }
                          </div>
                          <div className="text-nowrap mb-1">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              version.document?.internalApproval?.approvedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                      {version.document?.internalApproval?.status ===
                        "Rejected" && (
                        <>
                          <div className="d-flex align-items-center">
                          Client - Rejected by{" "}
                            {
                              version.document?.internalApproval?.rejectedBy
                                ?.name
                            }
                          </div>
                          <div className="text-nowrap">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              version.document?.internalApproval?.rejectedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                      {version.seperateDocumentForLandlord?.internalApproval
                        ?.status === "Pending" && (
                        <>
                          <div className="d-flex align-items-center">
                          Landlord - Requested by{" "}
                            {
                              version.seperateDocumentForLandlord
                                ?.internalApproval?.requestedBy?.name
                            }
                          </div>
                          <div className="text-nowrap">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              version.seperateDocumentForLandlord
                                ?.internalApproval?.requestedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                      {version.seperateDocumentForLandlord?.internalApproval
                        ?.status === "Approved" && (
                        <>
                          <div className="d-flex align-items-center">
                            Landlord - Invoice Approved by{" "}
                            {
                              version.seperateDocumentForLandlord
                                ?.internalApproval?.approvedBy?.name
                            }
                          </div>
                          <div className="text-nowrap">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              version.seperateDocumentForLandlord
                                ?.internalApproval?.approvedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                      {version.seperateDocumentForLandlord?.internalApproval
                        ?.status === "Rejected" && (
                        <>
                          <div className="d-flex align-items-center">
                          Landlord - Rejected by{" "}
                            {
                              version.seperateDocumentForLandlord
                                ?.internalApproval?.rejectedBy?.name
                            }
                          </div>
                          <div className="text-nowrap">
                            <span className="text-gray-600">On</span>{" "}
                            {moment(
                              version.seperateDocumentForLandlord
                                ?.internalApproval?.rejectedAt
                            ).format("DD MMM YYYY hh:mm A")}{" "}
                          </div>
                        </>
                      )}
                    </td>
                    <td className="font-sm">
                      {version.document?.paymentDetails ||
                      version.seperateDocumentForLandlord?.paymentDetails ? (
                        <>
                          {/* {version.document?.paymentDetails?.paymentStatus ===
                            "Paid" && (
                            <>
                              <div className="pt-2">
                                <div className="d-flex align-items-center">
                                  Client Marked As Paid By{" "}
                                  {
                                    version.document?.paymentDetails
                                      ?.markAsPaidBy?.name
                                  }
                                </div>

                                <div className="text-nowrap">
                                  <span className="text-gray-600">On</span>{" "}
                                  {moment(
                                    version.document?.paymentDetails
                                      ?.markAsPaidAt
                                  ).format("DD MMM YYYY hh:mm A")}{" "}
                                </div>
                              </div>
                            </>
                          )}
                          {version.seperateDocumentForLandlord?.paymentDetails
                            ?.paymentStatus === "Paid" && (
                            <>
                              <div className="pt-2">
                                <div className="d-flex align-items-center">
                                  Landlord Marked As Paid By{" "}
                                  {
                                    version.seperateDocumentForLandlord
                                      ?.paymentDetails?.markAsPaidBy?.name
                                  }
                                </div>

                                <div className="text-nowrap">
                                  <span className="text-gray-600">On</span>{" "}
                                  {moment(
                                    version.seperateDocumentForLandlord
                                      ?.paymentDetails?.markAsPaidAt
                                  ).format("DD MMM YYYY hh:mm A")}{" "}
                                </div>
                              </div>
                            </>
                          )} */}
                            {getLastActivity(version )}
                        </>
                      ) : (
                        <>
                          {props.stage === "Draft" && (
                            <>
                              <div className="d-flex align-items-center">
                                {props.title} Uploaded by{" "}
                                {version?.createdBy?.name}
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(version?.updatedAt).format(
                                  "DD MMM YYYY hh:mm A"
                                )}{" "}
                              </div>
                            </>
                          )}
                          {version.document?.internalApproval?.status ===
                            "Pending" && (
                            <>
                              <div className="d-flex align-items-center">
                                Internal Approval Request sent by{" "}
                                {
                                  version.document?.internalApproval
                                    ?.requestedBy?.name
                                }
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(
                                  version.document?.internalApproval
                                    ?.requestedAt
                                ).format("DD MMM YYYY hh:mm A")}{" "}
                              </div>
                            </>
                          )}
                          {version.document?.internalApproval?.status ===
                            "Approved" && (
                            <>
                              <div className="d-flex align-items-center">
                                Internal Approval Approved by{" "}
                                {
                                  version.document?.internalApproval?.approvedBy
                                    ?.name
                                }
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(
                                  version.document?.internalApproval?.approvedAt
                                ).format("DD MMM YYYY hh:mm A")}{" "}
                              </div>
                            </>
                          )}
                          {version.document?.internalApproval?.status ===
                            "Rejected" && (
                            <>
                              <div className="d-flex align-items-center">
                                Internal Approval Rejected by{" "}
                                {
                                  version.document?.internalApproval?.rejectedBy
                                    ?.name
                                }
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(
                                  version.document?.internalApproval?.rejectedAt
                                ).format("DD MMM YYYY hh:mm A")}{" "}
                              </div>
                            </>
                          )}
                          {version.seperateDocumentForLandlord?.internalApproval
                            ?.status === "Pending" && (
                            <>
                              <div className="d-flex align-items-center">
                                Internal Approval Requested by{" "}
                                {
                                  version.seperateDocumentForLandlord
                                    ?.internalApproval?.requestedBy?.name
                                }
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(
                                  version.seperateDocumentForLandlord
                                    ?.internalApproval?.requestedAt
                                ).format("DD MMM YYYY hh:mm A")}{" "}
                              </div>
                            </>
                          )}
                          {version.seperateDocumentForLandlord?.internalApproval
                            ?.status === "Approved" && (
                            <>
                              <div className="d-flex align-items-center">
                                Internal Approval Approved by{" "}
                                {
                                  version.seperateDocumentForLandlord
                                    ?.internalApproval?.approvedBy?.name
                                }
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(
                                  version?.seperateDocumentForLandlord
                                    ?.internalApproval?.approvedAt
                                ).format("DD MMM YYYY hh:mm A")}{" "}
                              </div>
                            </>
                          )}
                          {version.seperateDocumentForLandlord?.internalApproval
                            ?.status === "Rejected" && (
                            <>
                              <div className="d-flex align-items-center">
                                Internal Approval Rejected by{" "}
                                {
                                  version.seperateDocumentForLandlord
                                    ?.internalApproval?.rejectedBy?.name
                                }
                              </div>
                              <div className="text-nowrap">
                                <span className="text-gray-600">On</span>{" "}
                                {moment(
                                  version.seperateDocumentForLandlord
                                    ?.internalApproval?.rejectedAt
                                ).format("DD MMM YYYY hh:mm A")}{" "}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </td>
                    {/* <td className="font-sm">
                    {!!version.document ? <>Customer</> : <>Vendor/Owner</>}
                  </td> */}
                    <td className="font-sm">
                      <button
                        type="button"
                        className="btn btn-outline-primary bg-white text-primary px-4 font-normal font-weight-bold py-2 rounded mx-2 "
                        onClick={() => props.onView(version._id)}
                      >
                        View Invoice
                      </button>
                    </td>
                    <td className="font-sm font-weight-semibold">
                      <div
                        className="py-1 cursor-pointer text-right font-sm font-weight-semibold text-nowrap"
                        onClick={() =>
                          propDropdown === index
                            ? setPropDropdown(null)
                            : setPropDropdown(index)
                        }
                      >
                        View Details
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="chevron-down (98) 1">
                            <path
                              id="Vector"
                              d="M6 9L12 15L18 9"
                              stroke="#272B2A"
                              stroke-width="1.4"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </div>
                    </td>
                  </tr>
                  {propDropdown === index && (
                    <tr className="require-row">
                      <td colSpan={6}>
                        <div>
                          <table className="table floor-table table-bordered w-100 font-sm border-bottom">
                            <tr>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Floor</div>
                              </td>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Unit Id</div>
                              </td>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Area (in Sq.Ft)</div>
                              </td>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Interior Type</div>
                              </td>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Quoted Rent</div>
                              </td>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Current Status</div>
                              </td>
                              <td className="py-2 border-bottom">
                                <div className="py-1">Available From</div>
                              </td>
                              <td className="py-2 border-bottom font-sm">
                                <div className="py-1">Contact Details</div>
                              </td>
                            </tr>
                            {unitDetails?.map((unit: any) => {
                              const property =
                                unit?.propertyDetails
                                  ?.propertyDetailsFromProject;
                                  const propertyDetails = unit?.propertyDetails;

                              return (
                                <>
                                  <tr>
                                    <td className="py-3 border-bottom">
                                      <div className="">{property.floor}</div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                      <div className="">
                                        {property.unitName}
                                      </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                      <div className="">
                                        {property.area?.toFixed(2)}
                                      </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                      <div className="">
                                        {property?.interiorType}
                                      </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                      <div className="">
                                        {property?.quotedRent}{" "}
                                      </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                      <div className="">
                                        {convertPascalCaseToWords(
                                          property?.currentStatus
                                        )}
                                      </div>
                                    </td>
                                    <td className="py-3 border-bottom">
                                      {property?.availableFrom &&
                                        property?.availableFrom !==
                                          "1970-01-01T00:00:00.000Z" && (
                                          <div className="">
                                            {moment(
                                              property?.availableFrom
                                            ).format("DD-MM-YYYY")}
                                          </div>
                                        )}
                                    </td>
                                    <td
                                       className="py-2 border-bottom"
                                        style={{ width: "290px", maxWidth: "290px" }}
                                        >
                                            <div role="button" className="py-1 w-100 font-xs font-weight-semibold position-relative"
                                             onClick={(e) => dropdownClick(e, propertyDetails?._id, 'ContactDetails')}
                                             >
                                                { propertyDetails?.contactDetails?.length
                                                        ? propertyDetails?.contactDetails?.length > 2
                                                            ? propertyDetails.contactDetails
                                                                .slice(0, 2)
                                                                .map((participant: any) =>
                                                                    participant
                                                                        ? `${participant.contactName || ''}`
                                                                        : ''
                                                                )
                                                                .join(", ")
                                                            : propertyDetails?.contactDetails?.map((participant: any) =>
                                                                participant
                                                                    ? `${participant.contactName || ''}`
                                                                    : ''
                                                            )
                                                                .join(", ")
                                                        : ""}
                                                <span
                                                    className="text-primary cursor-pointer"
                                                   
                                                >
                                                    {propertyDetails?.contactDetails?.length > 2 ? ` +${propertyDetails?.contactDetails?.length - 2}` : ''}
                                                    {propertyDetails._id === dropPos?.id && dropPos?.fieldName === 'ContactDetails' &&
                                                         dropPos?.open && (
                                                            renderFieldDetails('Contact Details', propertyDetails?.contactDetails)
                                                        )}
                                                </span>
                                            </div>
                                        </td>
                                  </tr>
                                </>
                              );
                            })}
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}
                </>
              );
            })}
          </table>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default List;
